import React, { Fragment, useContext } from "react";
import { LayoutContext } from "../../../../../context/LayoutContext";
import {
  FlightCardTypes,
  KpiTypes,
} from "../../../../../enum/flights/FlightEnum";
import { KPISettingsIDs } from "../../../../../enum/FlightsEnum";
import { GlobalFilterOptionsEnum } from "../../../../../enum/global-filter/GlobalFilterEnum";
import { useApiCall } from "../../../../../hooks/useApiCall";
import { IKpiSettingsResponse } from "../../../../../models/app-settings/AppSettingsModels";
import { AIRPORT_CODE_PARAMETER } from "../../../../../utils/common/Constants";
import { FLIGHT_KPI_URLS_TEMPLATE } from "../../../../../utils/flights/FlightConstants";
import { getUpdatedKpiDataUrls } from "../../../../../utils/flights/FlightHelperFunctions";
import { KPICard } from "./KPICard";

const baseURL = process.env.REACT_APP_API_BASE_URL;
const kpiTimeURL = process.env.REACT_APP_API_GET_KPI_TIME;

interface IOverviewKPICardProps {
  airportCode: string;
}

export const OverviewKPICard: React.FunctionComponent<
  IOverviewKPICardProps
> = ({ airportCode }): React.JSX.Element => {
  const kpiTimeConfigUrl = `${baseURL}${kpiTimeURL}`.replace(
    AIRPORT_CODE_PARAMETER,
    airportCode
  );

  const { globalFilterDate, timezone, currentTime, selectedFilter } =
    useContext(LayoutContext);

  const { data: kpiTimeData } =
    useApiCall<IKpiSettingsResponse>({
      url: kpiTimeConfigUrl,
      dependencies: [airportCode],
    }) || {};
  const kpiConfigData = getUpdatedKpiDataUrls(
    airportCode,
    timezone,
    currentTime,
    globalFilterDate,
    selectedFilter as GlobalFilterOptionsEnum,
    kpiTimeData?.kpiSettings || [],
    FLIGHT_KPI_URLS_TEMPLATE
  );

  return (
    <Fragment>
      <KPICard
        airportCode={airportCode}
        cardName={FlightCardTypes.OTP}
        kpiConfigData={kpiConfigData?.[KPISettingsIDs.ON_TIME_PERFORMANCE]}
        kpitype={KpiTypes.OTP}
      />

      <KPICard
        airportCode={airportCode}
        cardName={FlightCardTypes.TURNAROUND_SUFFICIENCY}
        kpiConfigData={kpiConfigData?.[KPISettingsIDs.TURNAROUND_SUFFICIENCY]}
        kpitype={KpiTypes.TURNAROUND_SUFFICIENCY}
      />
    </Fragment>
  );
};
